var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeChannel = function SvgYoutubeChannel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "red",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.988 8.565a1.79 1.79 0 0 0-1.259-1.26C16.612 7 12.141 7 12.141 7s-4.47 0-5.588.294c-.6.165-1.094.659-1.259 1.27C5 9.683 5 12 5 12s0 2.33.294 3.435a1.79 1.79 0 0 0 1.259 1.26C7.683 17 12.14 17 12.14 17s4.47 0 5.588-.294a1.79 1.79 0 0 0 1.26-1.259c.293-1.118.293-3.435.293-3.435s.012-2.33-.294-3.447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m10.718 14.141 3.717-2.14-3.718-2.142z"
  })));
};
export default SvgYoutubeChannel;